import { ACTION_TYPES } from "../../../constants/index";

export const setMenuItems = (items) => ({
  type: ACTION_TYPES.SET_MENU_ITEMS,
  payload: items,
});

export const clearMenuItems = () => ({
  type: ACTION_TYPES.CLEAR_MENU_ITEMS,
});
